import { IUserInit } from "../interfaces/IUserInit";
import { DashboardUserRoute } from "../types/DashboardUserRouteTypes";

export class AccountantInit implements IUserInit{
    private dashboardUserRoute: DashboardUserRoute = 'accountant';

    public getDashboardUserRoute(){
        return this.dashboardUserRoute;
    }
}